import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=4387110b&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&id=4387110b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387110b",
  null
  
)

export default component.exports